import styled from 'styled-components';
import {dFlexCenter} from '../../../../../globalVariables/GlobalVariables';

export const sectionTitle = styled.p`
    ${dFlexCenter};
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    line-height: 140%;
    color: var(--color-text-default);
`;
